import api from '../utils/api';

export const FETCH_ATTENDANCE_REPORT_SUCCESS = 'FETCH_ATTENDANCE_REPORT_SUCCESS';
export const FETCH_ATTENDANCE_REPORT_FAIL = 'FETCH_ATTENDANCE_REPORT_FAIL';

export const fetchAttendanceReport = (start_date, end_date) => async (dispatch) => {
    try {
        const res = await api.get(`/reports/attendance?start_date=${start_date}&end_date=${end_date}`);
        dispatch({
        type: FETCH_ATTENDANCE_REPORT_SUCCESS,
        payload: res.data,
        });
        return res.data;
    } catch (error) {
        console.error('Error fetching attendance report:', error);
        dispatch({
        type: FETCH_ATTENDANCE_REPORT_FAIL,
        payload: error.message, // dispatch the error message as a string
        });
        throw error;
    }
};
  